import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCatalog } from "@/lib/query/core/invalidation";

type DeleteCategoryInput = {
  storeSlug: string;
  categoryId: string;
};

export function useDeleteCategoryMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ categoryId }: DeleteCategoryInput) =>
      apiJsonClient<unknown>(endpoints.seller.categoryById(categoryId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerCatalog(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
